import { useEffect, type ReactNode } from 'react';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';

import { useTenantFeatures, type TenantFeatures } from '@/shared/hooks/use-tenant-features';

interface RequireFeatureProps {
  feature: keyof TenantFeatures;
  children: ReactNode;
}

export function RequireFeature({ feature, children }: RequireFeatureProps): JSX.Element | null {
  const features = useTenantFeatures();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const isEnabled = features[feature] !== false;

  useEffect(() => {
    if (!isEnabled) {
      toast.warning(t('common.featureDisabled'));
      void navigate('/', { replace: true });
    }
  }, [isEnabled, navigate, t]);

  if (!isEnabled) return null;
  return <>{children}</>;
}
